import React, { Component } from 'react';
import "./survey-setup.css"
import { translate } from 'react-i18next';

import SingleSelect from "./input/single.js"
import TextEntry from "./input/text.js"
import FlatUIButton from "./input/flat-ui-button.js"

import { CircularProgress } from 'material-ui/Progress';

class SurveySetup extends Component {
  constructor(props) {
    super(props)

    this.state = {}

    this.addMessage = this.addMessage.bind(this)
    // this.submit = this.submit.bind(this)
  }

  addMessage(id, selected_answer, additional_data = null) {

    this.setState({
      [id]: {
        selected_answer: selected_answer,
        question_id: id,
        additional_data: additional_data
      }
    })
  }

  submit() {
    Object.keys(this.state).forEach(key => {
      this.props.addMessage(this.state[key], true)
    })
    // this.props.addMessage({
    //     selected_answer: selected_answer,
    //     question_id: this.props.input.question_id,
    //     additional_data: additional_data
    //   })
  }

  render() {
    const { t } = this.props;
    console.log("RENDERING STATIC SETUP", this.props, this.state)
    return (
      <div id="scroll-content" className="survey-setup-container">
        { 
          this.props.questions.map(q => {
            return (
              <div key={q.id}>
                <div className="white label-text"> { q.messages.map(msg => msg.text).join('\n') } </div>
                {
                  q.answer_choices.length > 0 
                  ?
                    <SingleSelect addMessage={(text, data) => this.addMessage(q.id, text, data)} id={q.id}
                      longAnswers={q.long_answers}
                      options={q.answer_choices}
                      isStatic={true}/>
                  :
                    <TextEntry addMessage={(text, data) => this.addMessage(q.id, text, data)} id={q.id}
                      singleline={q.singleline}
                      isStatic={true}/>

                }
              </div>
            )
          })
        }

        { this.props.errorMessage && 
          <p className="error">
            { this.props.errorMessage }
          </p>
        }

        <FlatUIButton 
            disabled={!this.props.questions.every(q => this.state[q.id] && this.state[q.id].selected_answer)} 
            className="rounded primary submit-button survey-setup-submit" 
            onClick={e => this.submit()}>
          {t('start')}
        </FlatUIButton>

        { this.props.loading && 
          <div>
            <CircularProgress />
          </div> 
        }
      </div>
    )
  }
}

export default translate('translations')(SurveySetup)


// WEBPACK FOOTER //
// ./src/components/survey-setup.js